module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'label-floating': _vm.labelFloating
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), (_vm.type === 'textarea') ? _c('textarea', _vm._b({
    staticClass: "form-control",
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }, 'textarea', _vm.$props, false)) : _c('input', _vm._b({
    staticClass: "form-control",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }, 'input', _vm.$props, false))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4998a79c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdFormGroupInput/index.vue
// module id = 2jIg
// module chunks = 13 14